import { ref } from 'vue'
import { ticketsExist } from '../api/tickets-exist'

export const hasSufficientTickets = ref(false)

export const loadTicketsExist = async () => {
  const data = await ticketsExist()
  hasSufficientTickets.value = data.exists
}
